import {getMomentFromCanvasTimelineDate} from './canvas-timeline/canvas_timeline_util';

/**
 * Syncs an allocation-like entity's domain date fields to a pair of canvas day
 * integers.
 *
 * Canvas items carry two independent notions of "when": the canvas dates used to
 * draw the bar, and these domain-object fields used to render text. Both
 * allocation tooltips (the React detail box and the canvas-drawn tooltip) read the
 * domain object, so any mover that shifts an allocation's canvas dates must call
 * this or the tooltip goes stale until a full refetch.
 *
 * Shared by all three movers: project_allocation_item.onMoving,
 * placeholder_allocation_item.onMoving and EventManager.onDistributionItemMoving.
 * Keep it that way — three divergent copies is what produced the bug.
 *
 * Start and end are converted independently: with "hide weekends" active the two
 * ends of an item receive different shifts, so there is no single uniform delta.
 *
 * Mutates and returns the entity. Note the two month conventions, both preserved
 * from the original call sites: the numeric *Month fields are 1-based, while the
 * Date objects are built from moment's 0-based month at local midnight.
 *
 * @param {object} allocation a projectAllocation or placeholderAllocation
 * @param {number} canvasStartDate canvas day integer for the new start
 * @param {number} canvasEndDate canvas day integer for the new end
 * @returns {object} the same entity, mutated
 */
export const syncAllocationDatesToCanvasDates = (allocation, canvasStartDate, canvasEndDate) => {
	const startDate = getMomentFromCanvasTimelineDate(canvasStartDate);
	const endDate = getMomentFromCanvasTimelineDate(canvasEndDate);

	allocation.startYear = startDate.year();
	allocation.startMonth = startDate.month() + 1;
	allocation.startDay = startDate.date();
	allocation.startDate = new Date(startDate.year(), startDate.month(), startDate.date());
	allocation.endYear = endDate.year();
	allocation.endMonth = endDate.month() + 1;
	allocation.endDay = endDate.date();
	allocation.endDate = new Date(endDate.year(), endDate.month(), endDate.date());

	return allocation;
};
